/*
import React, { useState } from "react";
import { STRINGS } from "./strings";
import { Box } from "@mui/material";
import CustomModal from "./CustomModal";
import { fontWeight } from "../../utils/constants/UI";
import { ACTIONS, BORDER, GREY } from "../../utils/constants/colors";
import TypographyInline from "../Typography/TypographyInline";
import Image from "../Image/Image";
import { OOPS_IMAGE } from "../../utils/constants/assets";
import { Button } from "../Buttons";
import { authEndpoints } from "../../utils/constants/httpConstants";
import { postRequest } from "../../Apis";
import { useNavigate } from "react-router-dom";
import { EMITTER_ERROR } from "../../utils/constants";
import EventEmitter from "../../utils/emitter/EventEmitter";

const styles = {

    bodyContainerView: {
        gap: "8px",
        display: "flex",
        justifyContent: " center",
        alignItems: "center",
        flexDirection: "column",
        borderBottom: `1px solid ${ACTIONS.DEFAULT}`

    },
    BodyCredits: {
        paddingBottom: "1rem"
    },
    BUTTON: {
        display: "block",
        margin: "auto",
        width: "fit-content",
        paddingTop: "1rem"
    }
}
const CreditsForRefferalModal = ({ open, close }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleChange = () => {
        close(!open)
    }

    const handleRequestForCredits = async () => {

        try {
            setLoading(true)
            await postRequest(navigate, authEndpoints.RequestForCredits);
            setLoading(false)
        } catch (error) {
            EventEmitter.emit(
                EMITTER_ERROR,
                error?.data?.message || STRINGS.ERR_MESSAGE
            );
            setLoading(false)
            close(!open)

        } finally {

            close(!open)
        }



    }
    const modalHeaderData = {
        heading: {
            id: STRINGS.HEAD,
            label: STRINGS.GET_MORE_CREDITS,
        },
    };
    const modalBodyData = (
        <Box>
            <Box style={styles.bodyContainerView} >

                <Image src={OOPS_IMAGE} />

                <TypographyInline
                    size={"lg"}
                    color={GREY.PRIMARY}
                    fontWeight={fontWeight.BOLD}
                    label={STRINGS.CREDIT_CONTENT}
                />
                <Box style={styles.BodyCredits}>
                    <TypographyInline
                        size={"sm"}
                        color={GREY.SECONDARY}
                        fontWeight={fontWeight.REGULAR}
                        label={STRINGS.REACH_FOR_CREDITS}
                    /></Box></Box>

            <Box style={styles.BUTTON}><Button
                label={STRINGS.REQUEST_FOR_MORE_CREDITS}
                size={"sm36"}
                variant={"primary"}
                onClick={handleRequestForCredits}
                isLoading={loading}
            /></Box>
        </Box>
    );




    return (
        <>
            <CustomModal
                width={"29.583vw"}
                close={handleChange}
                open={open}
                header={modalHeaderData}
                children={modalBodyData}

            />

        </>
    )
}


export default CreditsForRefferalModal
*/

import React from "react";
import { Box } from "@mui/material";
import CustomModal from "./CustomModal";
import { fontWeight } from "../../utils/constants/UI";
import {
  GREY,
  BASE,
  BORDER,
  PRIMARY,
  BRAND,
} from "../../utils/constants/colors";
import Typography from "../Typography/Typography";
import Image from "../Image/Image";
import { OOPS_IMAGE } from "../../utils/constants/assets";
import Button from "../Buttons/Button";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { PROFILE_PATH } from "../../utils/constants/routes";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "32px 32px 28px 32px",
    textAlign: "center",
    gap: "24px",
    background: "rgba(255, 255, 255, 0.8)",
    backdropFilter: "blur(12px)",
    borderRadius: "16px",
    position: "relative",
    overflow: "hidden",
  },
  imageContainer: {
    width: "140px",
    height: "140px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    filter: "drop-shadow(0px 8px 16px rgba(0,0,0,0.1))",
  },
  image: {
    width: "100%",
    height: "auto",
    animation: "float 3s ease-in-out infinite",
    "@keyframes float": {
      "0%": { transform: "translateY(0px)" },
      "50%": { transform: "translateY(-10px)" },
      "100%": { transform: "translateY(0px)" },
    },
  },
  contentSection: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    maxWidth: "460px",
  },
  buttonSection: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    gap: "14px",
    marginTop: "8px",
  },
  buttonWrapper: {
    flex: 1,
    minWidth: 0,
  },
  cancelWrapper: {
    marginTop: "12px",
    cursor: "pointer",
    padding: "8px 16px",
    borderRadius: "6px",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.05)",
    },
  },
};

const CreditsForRefferalModal = ({ open, close }) => {
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state?.userDetails?.payload);
  const isAdmin = userDetails?.role === "admin-user";

  const handleClose = () => {
    close(false);
  };

  const handleBuyCredits = () => {
    navigate(`${PROFILE_PATH}?tab=Billing`);
    close(false);
  };

  const handleUpgradePackage = () => {
    navigate(`${PROFILE_PATH}?tab=Billing`);
    close(false);
  };

  const modalHeaderData = {
    heading: {
      label: "Unlock More Credits",
    },
  };

  const modalBodyData = (
    <Box sx={styles.container}>
      {/* Image Section */}
      <Box sx={styles.imageContainer}>
        <Image src={OOPS_IMAGE} sx={styles.image} />
      </Box>

      {/* Content Section */}
      <Box sx={styles.contentSection}>
        <Typography
          size={"lg"}
          color={GREY.PRIMARY}
          fontWeight={fontWeight.BOLD}
          label={"You've Reached Your Credit Limit"}
        />
        <Typography
          size={"sm"}
          color={GREY.SECONDARY}
          fontWeight={fontWeight.REGULAR}
          label={
            isAdmin
              ? "Don't let this slow you down! Choose an option below to keep your outreach momentum going strong."
              : "You've run out of credits. Please contact your admin to purchase more credits."
          }
        />
      </Box>

      {/* Button Section - Role-based */}
      <Box sx={styles.buttonSection}>
        {isAdmin ? (
          <Box sx={styles.buttonWrapper}>
            <Button
              label="Buy More Credits"
              size="md40"
              variant="premium"
              onClick={handleBuyCredits}
            />
          </Box>
        ) : (
          <Box sx={styles.buttonWrapper}>
            <Button
              label="Contact Your Admin"
              size="md40"
              variant="premium"
              onClick={handleClose}
            />
          </Box>
        )}
      </Box>

      {/* Cancel Link */}
      <Box sx={styles.cancelWrapper} onClick={handleClose}>
        <Typography
          size={"sm"}
          color={GREY.TERTIARY}
          fontWeight={fontWeight.MEDIUM}
          label={"Maybe Later"}
        />
      </Box>
    </Box>
  );

  return (
    <CustomModal
      width={"540px"}
      close={handleClose}
      open={open}
      header={modalHeaderData}
      blurBackdrop={true}
    >
      {modalBodyData}
    </CustomModal>
  );
};

export default CreditsForRefferalModal;
